<template>
  <v-form ref="form" v-model="valid" lazy-validation @submit.prevent="onCreate">
    <v-card tile>
      <v-card-title class="grey lighten-2"
        >Lägg till från Commando</v-card-title
      >

      <v-card-text class="mt-2 pa-0">
        <MasterdataTableContainer
          show-select
          v-model="selected"
          :default-table-height="799"
          :loading="$apollo.loading"
          :headers="headers"
          :table-data="tableData"
          item-key="_uuid"
        ></MasterdataTableContainer>
      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions>
        <v-spacer />
        <v-btn rounded @click="closeModal">Avbryt</v-btn>
        <v-btn rounded type="submit" color="primary" :loading="createPending"
          >Skapa ersättningstrafik</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-form>
</template>

<script>
import gql from 'graphql-tag'
import { get } from 'vuex-pathify'
import { v4 as uuidv4 } from 'uuid'
import MasterdataTableContainer from '@/modules/masterdata/components/MasterdataTableContainer'
import replacementStatus from '../../../common/replacementStatus'

export default {
  name: 'ReplacementImportFromCommando',

  components: {
    MasterdataTableContainer
  },

  data: () => ({
    valid: true,
    createPending: false,
    selected: [],
    headers: [
      {
        text: 'Typ',
        value: '_type'
      },
      {
        text: 'Ersätter tåg.',
        value: 'train_number',
        width: 120
      },
      {
        text: 'Från',
        value: 'from',
        width: 200
      },
      {
        text: 'Till',
        value: 'to',
        width: 200
      },
      {
        text: 'Via',
        value: 'via'
      },
      {
        text: 'Status',
        value: '_status'
      }
    ]
  }),

  apollo: {
    unhandledReplacements: {
      fetchPolicy: 'no-cache',
      query: gql`
        {
          unhandledReplacements {
            external_uuid
            from
            from_signature
            to
            to_signature
            via
            via_signature
            type
            train_number
            status
            replacement {
              uuid
            }
          }
        }
      `
    }
  },

  computed: {
    selectedEventUUID: get('event/selectedUUID'),
    tableData() {
      return (this.unhandledReplacements || [])
        .filter(x => !x.replacement)
        .map(x => ({
          ...x,
          _status: replacementStatus[x.status],
          _type: x.type === 'SHUTTLE' ? 'Pendelbuss' : 'Tågersättningsbuss',
          _uuid: uuidv4()
        }))
    }
  },

  methods: {
    async onCreate() {
      const isValidForm = await this.$refs.form.validate()
      if (!isValidForm) return

      this.createPending = true
      console.log('creating...')
      const promises = []

      for (const item of this.selected) {
        const {
          // eslint-disable-next-line no-unused-vars
          _type,
          // eslint-disable-next-line no-unused-vars
          __typename,
          // eslint-disable-next-line no-unused-vars
          _uuid,
          // eslint-disable-next-line no-unused-vars
          replacement,
          // eslint-disable-next-line no-unused-vars
          _status,
          from_signature,
          to_signature,
          via_signature,
          ...payload
        } = item
        payload.event_uuid = this.selectedEventUUID
        payload.uuid = uuidv4()

        payload.from = from_signature
        payload.to = to_signature

        if (via_signature) {
          payload.via = via_signature
        }

        promises.push(
          this.$apollo.mutate({
            mutation: gql`
              mutation($payload: CreateReplacementInput!) {
                createReplacement(payload: $payload) {
                  replacement_uuid
                }
              }
            `,
            variables: {
              payload: {
                ...payload,
                checked: true
              }
            }
          })
        )

        this.$store.commit('replacement/create', {
          ...payload,
          checked: true
        })
      }

      await Promise.all(promises)

      this.createPending = false
      this.closeModal()
    },

    closeModal() {
      this.$emit('close')
    }
  }
}
</script>
